import React, { useEffect } from 'react';

// DEPENDENCIES
import HTMLReactParser from 'html-react-parser';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// GLOBAL HELPERS
import { useFormikContext } from 'formik';

// GLOBAL COMPONENTS
import Card from 'parts/card/Card';
import Form from 'core/form/Form';
import Record from 'parts/record/Record';

// MAIN COMPONENT
const AutomatedSpotInstructionsUpdate = () => (
  <Record.Update
    recordLabel="automated spot instruction"
    endpoints={ENDPOINTS.admin.spotInstructions.auto}
    formatRecord={(record = {}) => ({
      automatedSpotInstructionId: record.automated_spot_instruction_id,
      automatedSpotInstructionCode: record.automated_spot_instruction_code,
      automatedSpotInstructionTitle: record.automated_spot_instruction_title,
      triggeredBy: record.triggered_by,
      uploadDocumentRequired: record.upload_document_required
    })}
    formatParams={({ uploadDocumentEnabled, ...p }) => p}
  >
    <Card body={<FormBody />} />
  </Record.Update>
);

const FormBody = () => {
  const { values, setFieldValue } = useFormikContext() || {};

  const spotInstruction = HTMLReactParser(values.automatedSpotInstructionTitle ?? '');

  useEffect(() => {
    setFieldValue('isActive', 1);
  }, [setFieldValue, spotInstruction]);

  return (
    <Form.Body>
      <Form.PlainText label="Spot Instruction (Automated)" value={spotInstruction} />
      <Form.PlainText name="triggeredBy" label="Triggered By" />
      <Form.YesNo name="uploadDocumentRequired" label="Upload Document Required?" required />
      <Record.Log />
    </Form.Body>
  );
};

// EXPORT
export default AutomatedSpotInstructionsUpdate;
